/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SimilarRequestObjection,
    SimilarRequestObjectionFromJSON,
    SimilarRequestObjectionFromJSONTyped,
    SimilarRequestObjectionToJSON,
} from './';

/**
 * 
 * @export
 * @interface SimilarRequest
 */
export interface SimilarRequest {
    /**
     * 
     * @type {string}
     * @memberof SimilarRequest
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimilarRequest
     */
    response?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimilarRequest
     */
    documentName?: string | null;
    /**
     * 
     * @type {Array<SimilarRequestObjection>}
     * @memberof SimilarRequest
     */
    objections?: Array<SimilarRequestObjection> | null;
}

export function SimilarRequestFromJSON(json: any): SimilarRequest {
    return SimilarRequestFromJSONTyped(json, false);
}

export function SimilarRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimilarRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': !exists(json, 'text') ? undefined : json['text'],
        'response': !exists(json, 'response') ? undefined : json['response'],
        'documentName': !exists(json, 'documentName') ? undefined : json['documentName'],
        'objections': !exists(json, 'objections') ? undefined : (json['objections'] === null ? null : (json['objections'] as Array<any>).map(SimilarRequestObjectionFromJSON)),
    };
}

export function SimilarRequestToJSON(value?: SimilarRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'response': value.response,
        'documentName': value.documentName,
        'objections': value.objections === undefined ? undefined : (value.objections === null ? null : (value.objections as Array<any>).map(SimilarRequestObjectionToJSON)),
    };
}


